import React, { useState } from 'react';
import './SidebarDropdown.scss';

import UniversalCheckbox from 'components/uiComponents/UniversalCheckbox';
import { ReactComponent as SearchIcon } from 'static/icons/search-grey.svg';

import classNames from 'classnames';
import UniversalInput from '../../uiComponents/UniversalInput';

const SidebarDropdown = ({
  commonOptions = [],
  selectedItems,
  doubleColumns = false,
  optionsType,
  isSearch = true,
  isMultiSelect = true,
  onChangeSelectedItems,
}) => {
  const [search, setSearch] = useState('');

  const searchItem = search.toLowerCase();

  const searchedOptions = commonOptions.filter((item) => {
    const loweredItem = typeof item === 'string' ? item.toLowerCase() : item.toString();

    return loweredItem.indexOf(searchItem) >= 0;
  });

  const optionsArray = isSearch ? searchedOptions : commonOptions;

  const handleSearchChange = (value) => {
    setSearch(value);
  };

  const handleClearSearch = () => {
    setSearch('');
  };

  const handleCheckboxChange = (option) => {
    onChangeSelectedItems(option, optionsType);
  };

  const renderOptions = () => {
    const renderOptionElement = (option) => {
      if (isMultiSelect) {
        return (
          <UniversalCheckbox
            name={option}
            label={option}
            onChange={() => handleCheckboxChange(option)}
            checked={selectedItems?.some((item) => item === option)}
          />
        );
      } else {
        return (
          <p
            className={classNames('sidebar-dropdown__option__label', {
              'sidebar-dropdown__option__label-active': selectedItems?.some((item) => item === option),
            })}
            onClick={() => handleCheckboxChange(option)}
          >
            {option}
          </p>
        );
      }
    };

    return (
      <div
        className={classNames({
          'sidebar-dropdown__options-doubleColumns': doubleColumns,
          'sidebar-dropdown__options': !doubleColumns,
        })}
      >
        {optionsArray.map((option, index) => {
          return (
            <div key={option + index} className={'sidebar-dropdown__option__wrapper'}>
              <div className={'sidebar-dropdown__option'}>{renderOptionElement(option)}</div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className={'sidebar-dropdown'}>
      {isSearch && (
        <div className={'sidebar-dropdown__input'}>
          <UniversalInput
            leftIcon={<SearchIcon className={'sidebar-dropdown__search_icon'} />}
            name='search'
            type='text'
            id='search'
            placeholder='Search'
            onChangeValue={handleSearchChange}
            value={search}
            isClearButtonActive
            onClearSearch={handleClearSearch}
            required
          />
        </div>
      )}
      <div className={'sidebar-dropdown__options__container'}>{optionsArray?.length >= 0 && renderOptions()}</div>
    </div>
  );
};

export default SidebarDropdown;
